"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ODataStringVisitor = void 0;
const odata_expression_visitor_1 = require("./odata-expression-visitor");
/**
 * Converts an OData $filter expression from an AST generated by odata-parser back into
 * an OData filter string.
 *
 * @class ODataStringVisitor
 * @extends odata.ast.Visitor
 */
class ODataStringVisitor extends odata_expression_visitor_1.ODataExpressionVisitor {
    visitLiteralNode(node) {
        let value = node.value;
        if (node.value instanceof Array) {
            value = node.value[0];
        }
        if (value === 'null') {
            return 'null';
        }
        else if (typeof value === 'string') {
            return `'${value}'`;
        }
        else if (value instanceof Date) {
            return `datetime'${value.toISOString()}'`;
        }
        else {
            return value;
        }
    }
    visitPropertyNode(node) {
        return node.name;
    }
    visitConditionalNode(node, level) {
        const operator = node.type;
        const leftResult = odata_expression_visitor_1.ODataExpressionVisitor.accept(node.left, this, level);
        const rightResult = odata_expression_visitor_1.ODataExpressionVisitor.accept(node.right, this, level);
        return `${leftResult} ${operator} ${rightResult}`;
    }
    visitFunctionCallNode(node) {
        const self = this;
        const argValues = node.args.map(arg => odata_expression_visitor_1.ODataExpressionVisitor.accept(arg, self));
        return `${node.func}(${argValues.join(',')})`;
    }
    visitBinaryExpressionNode(node, level) {
        const operator = node.type;
        /*
         * if any of the left or right operands are binary expressions and the precedence of the directional nodes'
         * oprators are less than ours, then they must be logically grouped into brackets and evaluated first.
         */
        let leftValue = odata_expression_visitor_1.ODataExpressionVisitor.accept(node.left, this, level);
        if (this.isBinaryOperator(node.left) &&
            this.binaryOperatorPresedence(node.left) !==
                this.binaryOperatorPresedence(node)) {
            leftValue = `(${leftValue})`;
        }
        let rightValue = odata_expression_visitor_1.ODataExpressionVisitor.accept(node.right, this, level);
        if (this.isBinaryOperator(node.right) &&
            (this.isBinaryOperator(node.left) ||
                this.binaryOperatorPresedence(node.right) <
                    this.binaryOperatorPresedence(node))) {
            rightValue = `(${rightValue})`;
        }
        return `${leftValue} ${operator} ${rightValue}`;
    }
}
exports.ODataStringVisitor = ODataStringVisitor;
//# sourceMappingURL=odata-string-visitor.js.map